module.exports = (Promise.resolve(__parcel__require__("./" + "module.3b208c65.8599796d.js"))).then(() => parcelRequire('d5HBj'));